<template>
  <span>
    <!-- pooja, 17-jul-2025, 508- remove alt read as image -->
    <img
      :src="imgUrl"
      :alt="data.fields.description || ''"
      v-if="this.data.fields.file.contentType.startsWith('image')"
    />
    <!-- pooja, 17-jul-2025, 508- read pdf image as pdf document -->
    <a
      v-if="this.data.fields.file.contentType.includes('pdf')"
      :href="data.fields.file.url"
      target="_blank"
      :aria-label="`${pdfLinkDisplayText} availability in PDF Document`"
    >
      <span aria-hidden="true">{{ pdfLinkDisplayText }}</span>
      <!-- Pooja, 4-dec-25, read pdf icon alt as pdf -->
      <img aria-hidden="true" width="18" height="20" src="/assets/img/pdf.svg"
      :alt="data.fields.description || 'pdf'" role="presentation"
      />
    </a>
    <a
      v-if="this.data.fields.file.contentType.includes('text/csv')"
      :href="data.fields.file.url"
      target="_blank"
    >{{assetLinkDisplayText}}</a>

  </span>
</template>

<script>
import { urlSlug } from "@/helpers/url";
import _ from "lodash";

export default {
  name: "asset-component",
  props: ["data"],
  data() {
    return {
      isImage: false,
      isPdf: false,
      pdfLinkDisplayText: "",
      assetLinkDisplayText:""
    };
  },
  computed: {

    imgUrl() {
      return "http:" + this.data.fields.file.url;
    },
  },
  created() {

console.log('text data',this.$vnode.data.attrs.additionaldata[0])
    this.pdfLinkDisplayText = _.get(
      this,
      "$vnode.data.attrs.additionaldata[0].value",
      ""
    );

    this.assetLinkDisplayText=_.get(
      this,
      "$vnode.data.attrs.additionaldata[0].value"
    );
  },
};
</script>

<style lang="scss" scoped>
</style>



